module.exports = __webpack_public_path__ + "media/images/black-logo-244de826707b84f3ab63f240d0fb5a36.jpg";